import { render, staticRenderFns } from "./marketing_insight.vue?vue&type=template&id=44bdb1ac&scoped=true"
import script from "./marketing_insight.vue?vue&type=script&lang=js"
export * from "./marketing_insight.vue?vue&type=script&lang=js"
import style0 from "./marketing_insight.vue?vue&type=style&index=0&id=44bdb1ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bdb1ac",
  null
  
)

export default component.exports